import type { IconNode } from '../types';

/**
 * @name currency-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Im0xNyA3LTIuMTcgMi4xNyIgLz4KICA8cGF0aCBkPSJtMTcgMTctMi4xNy0yLjE3IiAvPgogIDxwYXRoIGQ9Im03IDE3IDIuMTctMi4xNyIgLz4KICA8cGF0aCBkPSJtNyA3IDIuMTcgMi4xNyIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/currency-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const currencySquare: IconNode = [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'afitv7' }],
  ['path', { d: 'm17 7-2.17 2.17', key: '80vp1n' }],
  ['path', { d: 'm17 17-2.17-2.17', key: '1c6l67' }],
  ['path', { d: 'm7 17 2.17-2.17', key: 'mqqi6j' }],
  ['path', { d: 'm7 7 2.17 2.17', key: '13m2w9' }],
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
];

export default currencySquare;
